<div class="transition duration-300 ease-in-out transform hover:-translate-y-1 hover:scale-100">
  <div class="outline-none hover:text-primary  sm: font-bold">{{title}}</div>
</div>